import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/images/theme/loading.gif'


const _hoisted_1 = { class: "columns" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center mt-5 pt-3"
}
const _hoisted_3 = { class: "friUserCircle2 friBack1" }
const _hoisted_4 = {
  class: "account-box is-navigation p-0 mt-0",
  style: {"border":"none !important"}
}
const _hoisted_5 = { class: "account-menu me-5" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-user-alt"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-quill"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-compact-left fs-3 align-middle me-3" }),
  /*#__PURE__*/_createTextVNode("Volver")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "ms-4 me-3"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "d-flex justify-content-center align-items-center mt-5 pt-3" }
const _hoisted_16 = { class: "friUserCircle2 friBack1" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = {
  key: 0,
  class: "text-center friColor3 fw-bold mt-5 text-xs3"
}
const _hoisted_19 = {
  key: 1,
  class: "py-5 px-4"
}
const _hoisted_20 = { class: "d-flex justify-content-center align-items-center fs-5" }
const _hoisted_21 = {
  key: 1,
  class: "text-center mt-5 w-100"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"150px","margin-top":"80px"}
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(!_ctx.layout.loading ? 'account-wrapper text-left' : 'w-100')
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.layout.user && _ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "account-box is-form is-footerless pb-0 mb-0",
            style: _normalizeStyle([_ctx.isMobile ? 'border: none !important;' : 'border: none !important;', {"background-color":"transparent"}])
          }, [
            (_ctx.layout.userOri)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.layout.userOri.first[0]) + _toDisplayString(_ctx.layout.userOri.last[0]), 1)
                ]))
              : _createCommentVNode("", true)
          ], 4))
        : _createCommentVNode("", true),
      (!_ctx.isMobile && _ctx.layout.user)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["column is-4 ms-3", _ctx.isMobile ? '' : 'mt-5'])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.sections, (section, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["account-menu-item cursor-pointer", _ctx.layout.section == section.name ? 'router-link-active router-link-exact-active' : '']),
                    onClick: ($event: any) => (_ctx.layout.section = section.name)
                  }, [
                    _hoisted_7,
                    _createElementVNode("span", null, [
                      _createElementVNode("i", {
                        class: _normalizeClass(section.icon + ' fs-3 align-middle me-3')
                      }, null, 2),
                      _createTextVNode(_toDisplayString(section.title), 1)
                    ]),
                    _hoisted_8
                  ], 10, _hoisted_6))
                }), 128)),
                _createElementVNode("div", {
                  class: "account-menu-item mt-2 cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path: '/device/' + _ctx.layout.appId , query: { section:  'users' } })))
                }, _hoisted_12)
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["column ps-0", _ctx.isMobile ? '' : 'mt-5'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-body p-0 m-0 friBackWhite vh-100", _ctx.isMobile ? 'pt-0 pb-1' : 'p-0'])
        }, [
          (!_ctx.layout.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_ctx.layout.user && _ctx.layout.section == 'dashboard')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_ctx.isMobile && _ctx.layout.userOri)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.layout.userOri.first[0]) + _toDisplayString(_ctx.layout.userOri.last[0]), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.layout.user)
                        ? (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["text-center fs-1", _ctx.isMobile ? 'fs-1' : 'fs-4'])
                              }, "Datos de usuario", 2),
                              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.layout.user.email), 1),
                              _createVNode(_component_ion_item, {
                                lines: "full",
                                class: "border-none",
                                style: {"--ion-item-border-color":"#ccc"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, {
                                    position: "floating",
                                    class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Nombre *")
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  _createVNode(_component_ion_input, {
                                    modelValue: _ctx.layout.user.first,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.layout.user.first) = $event)),
                                    type: "text"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, {
                                lines: "full",
                                class: "border-none",
                                style: {"--ion-item-border-color":"#ccc"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, {
                                    position: "floating",
                                    class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Apellidos *")
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  _createVNode(_component_ion_input, {
                                    modelValue: _ctx.layout.user.last,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.layout.user.last) = $event)),
                                    type: "text"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, {
                                class: "mt-2 border-none",
                                lines: "full",
                                style: {"--ion-item-border-color":"#ccc"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Activo")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_toggle, {
                                    "enable-on-off-labels": true,
                                    slot: "end",
                                    modelValue: _ctx.layout.user.active,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.layout.user.active) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              (!_ctx.layout.user.active)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, "El usuario inactivo no puede acceder a la aplicación, ni recibir notificaciones de alarma de la plataforma."))
                                : _createCommentVNode("", true),
                              (_ctx.layout.user.active)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("div", {
                                      class: "fs-6 mb-3 friColor1 cursor-pointer",
                                      style: {"text-decoration":"underline"},
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendUserWelcome()))
                                    }, "Reenviar email con datos de acceso")
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        style: _normalizeStyle(_ctx.isMobile ? 'margin-top: 20px; margin-bottom: 20px;' : 'margin-top: 30px;')
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", {
                            class: "friBtn1 br-5 cursor-pointer",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updUser()))
                          }, "GUARDAR")
                        ])
                      ], 4)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
        ], 2)
      ], 2)
    ])
  ], 2))
}